import { render, staticRenderFns } from "./MealDetail.vue?vue&type=template&id=0d7741ec&"
import script from "./MealDetail.vue?vue&type=script&lang=js&"
export * from "./MealDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports